import * as cafes from './cafes';
import * as cafesContract from './contract';
import * as auth from './auth';
import * as users from './users';
import * as payments from './payments';
import * as financialTransactions from './financialTransactions';
import * as settings from './settings';
import * as comments from './comments';
import * as changePassword from './changePassword';
import * as introducedCafes from './introducedCafes';
import * as messages from './messages';
import * as invoices from './invoices';
import * as menuCategories from './menuCategories';
import * as menuItems from './menuItems';
import * as reservations from './reservations';
import * as reserveTimes from './reserveTimes';
import * as dashboard from './dashboard';
import * as discountCodes from './discountCodes';
import * as workingHours from './workingHours';
import * as tickets from './tickets';
import * as cafeDiscounts from './cafeDiscounts';
import * as roles from './roles';
import * as rseeDiscounts from './rseeDiscounts';
import * as cafeEvents from './cafeEvents';
import * as ads from './ads';
import * as cafeTables from './cafeTables';
import * as notification from './notification';
import * as invoiceAdditions from './invoiceAdditions';
import * as checkout from './checkoutReports';
import * as checkoutsArchive from './checkoutsArchive';
import * as salesReport from './salesReport';
import * as completedReservesReport from './completedReservesReport';
import * as printers from "./printers";
import * as reservationTiming from './reservationTiming';
import * as takeaway from './takeaway';
import * as rseePackages from './rseePackages';
import * as giftChair from './giftChair';
import * as cities from './cities';
import * as regions from  './regions';

export default {
  cafes,
  cafesContract,
  auth,
  users,
  payments,
  financialTransactions,
  settings,
  comments,
  changePassword,
  introducedCafes,
  messages,
  invoices,
  menuCategories,
  menuItems,
  reservations,
  reserveTimes,
  dashboard,
  discountCodes,
  workingHours,
  tickets,
  cafeDiscounts,
  roles,
  rseeDiscounts,
  cafeEvents,
  ads,
  cafeTables,
  notification,
  invoiceAdditions,
  checkout,
  checkoutsArchive,
  salesReport,
  completedReservesReport,
  printers,
  reservationTiming,
  takeaway,
  rseePackages,
  giftChair,
  cities,
  regions,
};
